import api from './api';

const partnerInventoryService = {
  // Get all inventory items for partner
  getInventory: async () => {
    try {
      const response = await api.get('/products/partner/inventory/');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to fetch inventory'
      };
    }
  },

  // Get single inventory item
  getInventoryById: async (inventoryId) => {
    try {
      const response = await api.get(`/products/partner/inventory/${inventoryId}/`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to fetch inventory item'
      };
    }
  },

  // Create new inventory item
  createInventory: async (data) => {
    try {
      const response = await api.post('/products/partner/inventory/', data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to create inventory'
      };
    }
  },

  // Update inventory item
  updateInventory: async (inventoryId, data) => {
    try {
      const response = await api.patch(`/products/partner/inventory/${inventoryId}/`, data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to update inventory'
      };
    }
  },

  // Delete inventory item
  deleteInventory: async (inventoryId) => {
    try {
      const response = await api.delete(`/products/partner/inventory/${inventoryId}/`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to delete inventory'
      };
    }
  },

  // Search for existing products (autocomplete)
  searchProducts: async (query) => {
    try {
      const response = await api.get('/products/partner/search/', { params: { q: query } });
      return { success: true, data: response.data.results };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to search products'
      };
    }
  },

  // Match or create product
  matchProduct: async (productName) => {
    try {
      const response = await api.post('/products/partner/match/', { name: productName });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to match product'
      };
    }
  },

  // Get product variants
  getProductVariants: async (productId) => {
    try {
      const response = await api.get(`/products/partner/products/${productId}/variants/`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to fetch variants'
      };
    }
  },

  // Create product variant
  createVariant: async (productId, data) => {
    try {
      const response = await api.post(`/products/partner/products/${productId}/variants/`, data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || error.message || 'Failed to create variant'
      };
    }
  },
};

export default partnerInventoryService;
